export default {
	empty: {
		button: 'Visit Marketplace',
		description: 'Browse the Marketplace to purchase vehicles.',
		title: 'No vehicles in {slug}',
	},
	emptyKyc: {
		button: 'Go to company information',
		description:
			'To have full access to the Motorway platform and be able to bid on vehicles, you need to complete and submit your company information.',
		title: 'No vehicles in {slug}',
	},
	emptyKycSubmitted: {
		description: 'Our team is reviewing your company information and will contact you soon.',
	},
	error: {
		button: 'Refresh page',
		description:
			'There’s been a minor technical issue. Please refresh the page. If the problem persists, contact your Account Manager or Dealer Support Team.',
		title: 'Unable to display vehicles',
	},
	filters: {
		button: 'Clear all filters',
		description: 'We weren’t able to find any vehicles matching your criteria.',
		title: 'No vehicles found',
	},
};
